import type { PreviewTabKey } from "@/stores/shot-panel-store"

export type ShotTilePosterInput = {
  video_clip_url?: string | null
  storyboard_preview_url?: string | null
  video_first_frame_display_url?: string | null
}

function trimUrl(value: string | null | undefined): string {
  return typeof value === "string" ? value.trim() : ""
}

/**
 * Poster for shot tiles: video first frame (display) when the clip URL is present,
 * else the key frame. Without a clip URL (studio tree) the key frame still wins,
 * and a video-only shot falls back to the stored first frame.
 */
export function shotTilePosterUrl(shot: ShotTilePosterInput): string | null {
  const hasVideo = trimUrl(shot.video_clip_url) !== ""
  const firstFrame = trimUrl(shot.video_first_frame_display_url)
  const storyboard = trimUrl(shot.storyboard_preview_url)

  if (hasVideo && firstFrame) return firstFrame
  return storyboard || firstFrame || null
}

/** Instant preview tab when opening a shot from a tile (video without key frame). */
export function shotTileOpenPreviewTab(
  shot: Pick<ShotTilePosterInput, "video_clip_url" | "storyboard_preview_url">,
): PreviewTabKey | undefined {
  const hasVideo = trimUrl(shot.video_clip_url) !== ""
  const hasStoryboard = trimUrl(shot.storyboard_preview_url) !== ""
  if (hasVideo && !hasStoryboard) return "video"
  return undefined
}
